
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";
import echarts from "echarts";
import t from "@common/src/i18n/t";
const statement = namespace("statement");
const base = namespace("base");
const service = namespace("service");
const parts = namespace("parts");
const store = namespace("store");
const setting = namespace("setting");
@Component({})
export default class ServiceWorkshopView extends Vue {
  @statement.Action getTurnOverAnalysisModel;
  @base.Action getDictionaryList;
  @parts.Action getPartsList;
  @service.Action getOrderTimeoutDashboard;
  @service.Action queryTodayOrderDashboard;
  @service.Action settingOrderTimeoutDashboard;
  @service.Action statisticTechnicianWorkingHoursDashboard;
  @service.Action statisticalTodayOrderDashboard;
  @store.State storeData;
  @setting.State dispatchMode;

  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  contentList: any = [];
  originList: any = [];
  showModel: Boolean = false;
  formData: any = {
    timeout: ""
  };
  formDataRules: any = {
    timeout: [
      { required: true, message: t("v210831.please-enter-time-consuming"), trigger: "blur" },
      { required: true, pattern: /^[0-9]*$/, message: t("v210831.incorrect-format"), trigger: "blur" },
      {
        validator: (rule, value, callback) => {
          if (Number(this.formData.timeout) > 0) {
            callback();
          } else {
            callback(new Error(t("v210831.the-time-consuming")));
          }
        },
        trigger: "blur"
      }
    ]
  };
  OrderTimeout: any = "";
  listTotal: number = 0;
  listMaxPage: number = 1;
  pageNum: number = 1;
  pageSize: number = 5;
  storeInfo: any = {};
  realTime: any = "";
  currentTime: any = new Date();
  interval: any = null;
  timeNumber: number = 0;
  isFullScreen: boolean = false;
  assignTaskModeCode: any = "";

  created() {
    if (this.storeData) {
      let storeInfo = this.storeData;
      this.storeInfo = storeInfo;
    }
    this.assignTaskModeCode = this.dispatchMode;
    this.init();
    this.interval = setInterval(() => {
      this.timeNumber = this.timeNumber * 1 + 1;
      if (this.timeNumber % 60 === 0) {
        this.pageNum = 1;
        this.init();
      } else if (this.timeNumber % 10 === 0) {
        if (this.listMaxPage) {
          this.pageNum = (this.pageNum % this.listMaxPage) + 1;
        }
        this.setList();
      }
    }, 1000);
    this.$nextTick(() => {
      this.switchFullScreen();
    });
  }
  switchFullScreen() {
    if (this.isFullScreen) {
      this.exit();
    } else {
      let elem = document.querySelector(".workshop");
      let requestMethod =
        elem["requestFullScreen"] ||
        elem["webkitRequestFullScreen"] ||
        elem["mozRequestFullScreen"] ||
        elem["msRequestFullScreen"];
      if (requestMethod) {
        requestMethod.call(elem);
      } else if (typeof (window as any).ActiveXObject !== "undefined") {
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    }
    this.isFullScreen = !this.isFullScreen;
  }
  getRealTime() {
    let timing = new Date();
    this.currentTime = timing;
    let week = {
      0: t("v210831.sunday"),
      1: t("v210831.monday"),
      2: t("v210831.tuesday"),
      3: t("v210831.wednesday"),
      4: t("v210831.thursday"),
      5: t("v210831.friday"),
      6: t("v210831.saturday")
    };
    this.realTime =
      dayjs(timing).format("YYYY") +
      t("v210831.year") +
      dayjs(timing).format("MM") +
      t("base.month") +
      dayjs(timing).format("DD") +
      t("v210831.day") +
      week[dayjs(timing).format("d")] +
      dayjs(timing).format(" HH:mm:ss");
  }
  beforeDestroy() {
    clearInterval(this.interval);
  }
  handleCloseModel() {
    this.showModel = false;
    (this.$refs["formData"] as any).clearValidate();
  }
  init() {
    this.getOrderTimeout();
    this.getTableData();
    this.getChartData();
  }
  exit() {
    this.$router.go(-1);
  }
  showSetting() {
    this.showModel = true;
  }
  handleComplete() {
    (this.$refs["formData"] as any).validate(valid => {
      if (valid) {
        this.settingOrderTimeoutDashboard(this.formData).then(() => {
          this.$message.success(t("v210831.set-successfully"));
          this.init();
          this.showModel = false;
        });
      }
    });
  }
  getTableData() {
    this.queryTodayOrderDashboard().then(data => {
      let list = data.data;
      list.forEach(item => {
        let startTime = null;
        let endTime = null;
        if (this.assignTaskModeCode === "1") {
          item.assignTime && (startTime = new Date(item.assignTime).getTime());
        } else {
          item.orderTime && (startTime = new Date(item.orderTime).getTime());
        }
        if (item.orderStatus === "4") {
          item.completedTime && (endTime = new Date(item.completedTime).getTime());
        } else {
          endTime = new Date(this.currentTime).getTime();
        }
        if (startTime && endTime) {
          item["timing"] = Math.ceil((endTime - startTime) / 1000 / 60);
        } else {
          item["timing"] = "";
        }
      });
      this.listTotal = list.length;
      this.listMaxPage = Math.ceil(list.length / Number(this.pageSize));
      this.originList = list;
      this.setList();
    });
  }
  setList() {
    let list = this.originList;
    this.contentList = list.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize);
  }
  getOrderTimeout() {
    this.getOrderTimeoutDashboard().then(data => {
      if (data.data) {
        this.OrderTimeout = Number(data.data);
        this.formData.timeout = this.OrderTimeout;
      }
    });
  }

  getChartData() {
    // 柱状图 barChart
    this.statisticTechnicianWorkingHoursDashboard().then(res => {
      let data = res.data;
      if (!data || !data.length) {
        return;
      }
      let nameList = data.map(v => v.technicianName);
      nameList.reverse();
      let series = [];
      let max = 0;
      data.forEach(item => {
        if (item.itemArray && item.itemArray.length > max) {
          max = item.itemArray.length;
        }
      });
      data.forEach(item => {
        for (let i = 0; i < max; i++) {
          if (!series[i]) {
            series[i] = {
              type: "bar",
              stack: t("v210831.total"),
              barGap: 0,
              label: {
                show: true,
                formatter: params => {
                  return params.value + "m";
                }
              },
              data: []
            };
          }
          if (item.itemArray[i]) {
            let workingHours = item.itemArray[i].workingHours;
            series[i].data.push({ item: item.itemArray[i], value: workingHours });
          } else {
            series[i].data.push(null);
          }
        }
      });
      series.forEach(v => {
        v.data.reverse();
      });
      let ChartData = {
        nameList,
        series
      };
      this.setChart(ChartData, "barChart", "bar");
    });
    // 饼图 pieChart
    this.statisticalTodayOrderDashboard().then(res => {
      let data = res.data;
      let ChartData = {
        data: [
          { name: t("test.has-been-created"), value: data.createCount },
          { name: t("v210831.dispatched"), value: data.assignCount },
          { name: t("v210831.picked"), value: data.receiveMaterialsCount },
          { name: t("test.have-been-completed"), value: data.completedCount }
        ],
        total: data.count,
        text: t("v210831.today’s-arrival-(set)")
      };
      this.setChart(ChartData, "pieChart", "pie");
    });
  }
  setChart(data, refName, type) {
    let MyChart = echarts.init(this.$refs[refName]);
    let options = {};
    if (type === "pie") {
      // 饼图pie
      options = {
        color: ["#2278F5", "#599AFA", "#00B478", "#30C191"],
        backgroundColor: "#323447",
        textStyle: {
          color: "#ffffff"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          bottom: "0%",
          left: "center",
          x: "center",
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 24,
          textStyle: {
            color: "#ffffff"
          }
        },
        title: {
          show: true,
          text: data.text,
          subtext: splitThousands(data.total),
          top: "43%",
          left: "center",
          textStyle: {
            color: "#ffffff",
            fontWeight: 400,
            fontSize: 12
          },
          subtextStyle: {
            color: "#ffffff",
            fontWeight: 500,
            fontSize: 18
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: true,
            label: {
              formatter: val => {
                return `${val.name} ${val.value}`;
              }
            },
            data: data.data
          }
        ]
      };
    } else if (type === "bar") {
      // 柱状图bar
      options = {
        color: ["#2278F5", "#599AFA", "#00B478", "#30C191"],
        backgroundColor: "#323447",
        textStyle: {
          color: "#ffffff"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: params => {
            console.log(params);
            let str = `${params[0].name}<br/>`;
            params.forEach(item => {
              if (item.data) {
                str += `${item.marker} ${item.data.item.plateCode}:${item.value}m<br/>`;
              }
            });
            return str;
          }
        },
        legend: {
          show: false
        },
        xAxis: [
          {
            type: "value",
            max: 720,
            splitNumber: 5,
            minInterval: 120,
            maxInterval: 120,
            axisLabel: {
              formatter: params => {
                if (params) {
                  return params / 60 + "H";
                }
                return 0;
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#ffffff",
                type: "dashed"
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "category",
            splitLine: {
              show: true
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: data.nameList
          }
        ],
        series: data.series
      };
    }
    MyChart.setOption(options);
    window.addEventListener("resize", () => {
      MyChart.resize();
    });
  }
}
